import CheckTag from './src/check-tag2.mjs';
export { checkTagEmits, checkTagProps } from './src/check-tag.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCheckTag = withInstall(CheckTag);

export { ElCheckTag, ElCheckTag as default };
//# sourceMappingURL=index.mjs.map
